export default {
  en: {
    calls: 'Calls',
    queues: 'Queues',
    'extra-data': 'Metadata',
    comments: 'Comments',
    appointments: 'Appointments',
    forms: 'Forms',
    tags: 'Tags',
    recordings: 'Recordings',
    users: 'Users',
    'ai-topics': 'AI Topics',
    'ai-sentiments': 'AI Sentiments',
    'ai-summaries': 'AI Summaries',
    columns: {
      id: 'Identifier',
      segment: 'Segment',
      agent: 'Agent',
      call: 'Call',
      appointment: 'Appointment',
      queue: 'Queue',
      createdAt: 'Date',
      startTime: 'Start',
      endTime: 'End',
      duration: 'Duration',
      extraData: 'Meta Data',
      canceled: 'Abandoned',
      assigned: 'Assigned',
      dismissed: 'Rejected',
      canceledReason: 'Cancellation Reason',
      customerLeave: 'Customer Left',
      survey: 'Survey',
      comments: 'Comments',
      tag: 'Tag ID',
      tags: 'Tags',
      transferredAgent: 'Transferred to Agent',
      transferredSegment: 'Transferred to Segment',
      disconnections: 'Disconnections',
      connections: 'Connections',
      userAgent: 'User Agent',
      osName: 'Operating System (name)',
      osVersion: 'Operating System (version)',
      browserName: 'Browser (name)',
      browserVersion: 'Browser (version)',
      ip: 'IP',
      ipType: 'IP Type',
      referrer: 'Referred',
      timezone: 'Timezone',
      langCode: 'Language (code)',
      langNative: 'Language',
      langName: 'Language (name)',
      carrierName: 'ISP',
      carrierDomain: 'ISP (domain)',
      continentName: 'Continent (name)',
      continentCode: 'Continent (code)',
      countryName: 'Country',
      countryCode: 'Country (code)',
      regionName: 'Region',
      regionCode: 'Region (code)',
      cityName: 'City',
      coordinates: 'Coordinates',
      deviceType: 'Device',
      agentForm: 'Agent Form ID',
      surveyId: 'Survey ID',
      baseForm: 'Customer Form ID',
      url: 'URL',
      tagName: 'Tag ID',
      tagLabel: 'Tag Name',
      createdBy: 'Created by',
      consent: 'Date of customer consent',
      sentimentText: 'Sentiment Text',
      sentimentNumber: 'Sentiment Number',
      requestedAt: 'Requested At',
      summary: 'Summary',
      topicName: 'Topic Name',
      topicScore: 'Topic Score',
    },
    singleFileExport: 'Unified',
    multipleFileExport: 'Individual',
    xlsx: {
      description: 'It will download a single XLSX file with multiple sheets',
      alertDates: 'The datasets will download between the dates {start} and {end}',
    },
    downloading: 'Downloading the dataset: {dataset}...',
  },
  es: {
    calls: 'Llamadas',
    queues: 'Filas',
    'extra-data': 'Meta datos',
    comments: 'Comentarios',
    appointments: 'Reuniones',
    forms: 'Formularios',
    tags: 'Etiquetas',
    recordings: 'Grabaciones',
    users: 'Usuarios',
    'ai-topics': 'Temas de IA',
    'ai-sentiments': 'Sentimientos de IA',
    'ai-summaries': 'Resúmenes de IA',
    columns: {
      id: 'Identificador',
      segment: 'Segmento',
      agent: 'Agente',
      call: 'Llamada',
      appointment: 'Cita',
      queue: 'Fila',
      createdAt: 'Fecha',
      startTime: 'Inicio',
      endTime: 'Fin',
      duration: 'Duración',
      extraData: 'Meta Data',
      canceled: 'Abandonada',
      assigned: 'Asignada',
      dismissed: 'Rechazada',
      canceledReason: 'Razón Cancelación',
      customerLeave: 'Cliente cortó',
      survey: 'Encuesta',
      comments: 'Comentarios',
      tag: 'ID Etiqueta',
      tags: 'Etiquetas',
      transferredAgent: 'Transferido a agente',
      transferredSegment: 'Transferido a segmento',
      disconnections: 'Desconexiones',
      connections: 'Conexiones',
      userAgent: 'Usuario agente',
      osName: 'Sistema operativo (nombre)',
      osVersion: 'Sistema operativo (version)',
      browserName: 'Navegador (nombre)',
      browserVersion: 'Navegador (version)',
      ip: 'IP',
      ipType: 'Tipo IP',
      referrer: 'Referido',
      timezone: 'Zona horaria',
      langCode: 'Idioma (code)',
      langNative: 'Idioma',
      langName: 'Idioma (nombre)',
      carrierName: 'ISP',
      carrierDomain: 'ISP (domain)',
      continentName: 'Continente (nombre)',
      continentCode: 'Continente (code)',
      countryName: 'País',
      countryCode: 'País (code)',
      regionName: 'Region',
      regionCode: 'Region (code)',
      cityName: 'Ciudad',
      coordinates: 'Coordenadas',
      deviceType: 'Dispositivo',
      agentForm: 'ID formulario agente',
      surveyId: 'ID Encuesta',
      baseForm: 'ID formulario cliente',
      url: 'URL',
      tagName: 'ID Etiqueta',
      tagLabel: 'Nombre Etiqueta',
      createdBy: 'Creado por',
      consent: 'Fecha de consentimiento del cliente',
      sentimentText: 'Texto del Sentimiento',
      sentimentNumber: 'Número del Sentimiento',
      requestedAt: 'Solicitado en',
      summary: 'Resumen',
      topicName: 'Nombre del Topico',
      topicScore: 'Puntuación del Topico',
    },
    singleFileExport: 'Unificada',
    multipleFileExport: 'Individual (obsoleta)',
    xlsx: {
      description: 'Se descargará un único archivo XLSX con múltiples hojas',
      alertDates: 'Los conjuntos de datos se descargarán entre las fechas {start} y {end}',
    },
    downloading: 'Descargando el conjunto de datos: {dataset}...',
  },
  fr: {
    calls: 'Appels',
    queues: 'Files d\'attente',
    'extra-data': 'Métadonnées',
    comments: 'Commentaires',
    appointments: 'Rendez-vous',
    forms: 'Formulaires',
    tags: 'Étiquettes',
    recordings: 'Enregistrements',
    users: 'Utilisateurs',
    'ai-topics': 'Sujets d\'IA',
    'ai-sentiments': 'Sentiments d\'IA',
    'ai-summaries': 'Résumés d\'IA',
    columns: {
      id: 'Identifiant',
      segment: 'Segment',
      agent: 'Agent',
      call: 'Appel',
      appointment: 'Rendez-vous',
      queue: 'File d\'attente',
      createdAt: 'Date',
      startTime: 'Début',
      endTime: 'Fin',
      duration: 'Durée',
      extraData: 'Métadonnées',
      canceled: 'Abandonné',
      assigned: 'Assigné',
      dismissed: 'Rejeté',
      canceledReason: 'Raison de l\'annulation',
      customerLeave: 'Client parti',
      survey: 'Enquête',
      comments: 'Commentaires',
      tag: 'ID de l\'étiquette',
      tags: 'Étiquettes',
      transferredAgent: 'Transféré à l\'agent',
      transferredSegment: 'Transféré au segment',
      disconnections: 'Déconnexions',
      connections: 'Connexions',
      userAgent: 'Agent utilisateur',
      osName: 'Système d\'exploitation (nom)',
      osVersion: 'Système d\'exploitation (version)',
      browserName: 'Navigateur (nom)',
      browserVersion: 'Navigateur (version)',
      ip: 'IP',
      ipType: 'Type d\'IP',
      referrer: 'Référé',
      timezone: 'Fuseau horaire',
      langCode: 'Langue (code)',
      langNative: 'Langue',
      langName: 'Langue (nom)',
      carrierName: 'Fournisseur d\'accès',
      carrierDomain: 'Fournisseur d\'accès (domaine)',
      continentName: 'Continent (nom)',
      continentCode: 'Continent (code)',
      countryName: 'Pays',
      countryCode: 'Pays (code)',
      regionName: 'Région',
      regionCode: 'Région (code)',
      cityName: 'Ville',
      coordinates: 'Coordonnées',
      deviceType: 'Appareil',
      agentForm: 'ID du formulaire de l\'agent',
      surveyId: 'ID de l\'enquête',
      baseForm: 'ID du formulaire client',
      url: 'URL',
      tagName: 'ID de l\'étiquette',
      tagLabel: 'Nom de l\'étiquette',
      createdBy: 'Créé par',
      consent: 'Date de consentement du client',
      sentimentText: 'Texte du Sentiment',
      sentimentNumber: 'Numéro du Sentiment',
      requestedAt: 'Demandé à',
      summary: 'Résumé',
      topicName: 'Nom du Sujet',
      topicScore: 'Score du Sujet',
    },
    singleFileExport: 'Unifié',
    multipleFileExport: 'Individuel',
    xlsx: {
      description: 'Cela téléchargera un seul fichier XLSX avec plusieurs feuilles',
      alertDates: 'Les ensembles de données seront téléchargés entre les dates {start} et {end}',
    },
    downloading: 'Téléchargement de l\'ensemble de données : {dataset}...',
}

};
